export {};

const prevArrow = NLMK.generateSlickArrow('left', 'prev');
const nextArrow = NLMK.generateSlickArrow('right', 'next');

$(init);

NLMK.initMobileSlider = init;

function init() {
    $('.js-slider-mobile').each(eachSlider);
}

function eachSlider(sliderIndex, SliderElement) {
    const $slider = $(SliderElement);

    if ($slider.data('init-mobile-slider')) {
        return true;
    }

    $slider.data('init-mobile-slider', true);
    let isCurrentMobile;
    const infinite = $slider.data('infinite');
    const centerMode = $slider.data('center-mode');
    const options = {
        initialSlide: 0,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: NLMK.mediaQueries.mobile.min,
                settings: {
                    dots: true,
                    arrows: true,
                    infinite: typeof infinite !== 'undefined' ? infinite : false,
                    centerMode: typeof centerMode !== 'undefined' ? centerMode : true,
                    prevArrow,
                    nextArrow,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                },
            },
        ],
    };

    toggleSlider();

    $(window).on('resize', toggleSlider);

    function toggleSlider() {
        const isMobile = NLMK.mediaQueries.isMobile();

        if (isCurrentMobile !== isMobile) {
            isCurrentMobile = isMobile;

            if (isMobile) {
                initSlider();
            } else {
                destroySlider();
            }
        }
    }

    function destroySlider() {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }
    }

    function initSlider() {
        $slider.slick(options);
    }
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/mobile.js